'use client';

import { useState, useEffect } from 'react';
import HeroSection from './HeroSection';
import FeaturedCreatorsSection from './FeaturedCreatorsSection';
import MonetizationSection from './MonetizationSection';
import SuccessStoriesSection from './SuccessStoriesSection';
import CreatorPortalSection from './CreatorPortalSection';
import ResourcesSection from './ResourcesSection';
import CTASection from './CTASection';
import FooterSection from './FooterSection';

export default function CreatorCommunityInteractive() {
  const [isHydrated, setIsHydrated] = useState(false);

  useEffect(() => {
    setIsHydrated(true);
  }, []);

  const handleGetStartedClick = () => {
    if (!isHydrated) return;
    
    const portalSection = document.getElementById('creator-portal');
    if (portalSection) {
      portalSection?.scrollIntoView({ behavior: 'smooth' });
    }
  };

  if (!isHydrated) {
    return (
      <div className="min-h-screen bg-background">
        <HeroSection onGetStartedClick={() => {}} />
        <FeaturedCreatorsSection />
        <MonetizationSection />
        <SuccessStoriesSection />
        <div id="creator-portal">
          <CreatorPortalSection />
        </div>
        <ResourcesSection />
        <CTASection />
        <FooterSection />
      </div>
    );
  }

  return (
    <div className="min-h-screen bg-background">
      <HeroSection onGetStartedClick={handleGetStartedClick} />
      <FeaturedCreatorsSection />
      <MonetizationSection />
      <SuccessStoriesSection />
      <div id="creator-portal">
        <CreatorPortalSection />
      </div>
      <ResourcesSection />
      <CTASection />
      <FooterSection />
    </div>
  );
}